import React, { useEffect } from "react";

import {
  UNTIMED,
  TIMED,
  UNRESTRICTED,
  BROWSER_LOCK,
  LOCKDOWN_BROWSER,
  FIXED_TIMED,
} from "Worksheet/modules/WorksheetConstants";
import { getIsWorksheetAssignModalV2Enabled } from "Worksheet/modules/WorksheetFeatureFlags";
import classes from "./DeliverySettingsV2.scss";
import {
  ClockOutlined,
  LockOutlined,
  WorksheetClipboardOutlined,
  CaretDownFilled,
  LockOpenOutlined,
  PolicyOutlined,
} from "@toddle-edu/ds-icons";
import {
  CardSelection,
  Dropdown,
  DropdownMenu,
  Button,
} from "@toddle-edu/ds-web";
import DurationDropdown from "../DurationDropdown";
import _ from "lodash";

const containerStyles = {
  width: "100%",
};

const DeliverySettingsV2 = props => {
  const {
    timeSettings,
    modeSettings,
    timeDuration,
    updateSelectedItems,
    isTimedTestEnabled,
    isFixedStartTime,
    isLockScreenEnabled,
    isSafeBrowserEnabled,
    mode,
    t,
    showWorksheetTypesHeading = false,
    sourceAssignmentWorksheetSettings = {},
  } = props;

  // UseEffect to change state for worksheet related settings
  useEffect(() => {
    if (!_.isEmpty(sourceAssignmentWorksheetSettings)) {
      const timedTestDuration =
        _.get(sourceAssignmentWorksheetSettings, "timedTestDuration", 60) || 60;
      updateSelectedItems({
        isFixedStartTime: _.get(
          sourceAssignmentWorksheetSettings,
          "isFixedStartTime",
          false
        ),
        isLockScreenEnabled: _.get(
          sourceAssignmentWorksheetSettings,
          "isLockScreenEnabled",
          false
        ),
        isSafeBrowserEnabled: _.get(
          sourceAssignmentWorksheetSettings,
          "isSafeBrowserEnabled",
          false
        ),
        isTimedTestEnabled: _.get(
          sourceAssignmentWorksheetSettings,
          "isTimedTestEnabled",
          false
        ),
        timedTestDuration: {
          hours: Math.floor(timedTestDuration / 60),
          minutes: timedTestDuration % 60,
        },
      });
    }
  }, []);

  const selectedValue = isTimedTestEnabled
    ? isFixedStartTime
      ? FIXED_TIMED
      : TIMED
    : UNTIMED;

  const securityMode = isSafeBrowserEnabled
    ? LOCKDOWN_BROWSER
    : isLockScreenEnabled
    ? BROWSER_LOCK
    : UNRESTRICTED;

  const onTimeSettingSelectionClick = values => {
    const value = _.first(values);
    updateSelectedItems({
      isTimedTestEnabled: value === TIMED || value === FIXED_TIMED,
      isFixedStartTime: value === FIXED_TIMED,
    });
    if (value === UNTIMED) {
      updateSelectedItems({
        isLockScreenEnabled: false,
        isSafeBrowserEnabled: false,
      });
    }
  };

  const changeSecurityMode = ({ key }) => {
    updateSelectedItems({
      isLockScreenEnabled: key === BROWSER_LOCK,
      isSafeBrowserEnabled: key === LOCKDOWN_BROWSER,
    });
  };
  const securityOptions = [
    {
      key: UNRESTRICTED,
      label: t("worksheet:no_restriction"),
      icon: <LockOpenOutlined />,
    },
    {
      key: BROWSER_LOCK,
      label: t("worksheet:browser_lock"),
      icon: <LockOutlined />,
    },
    {
      key: LOCKDOWN_BROWSER,
      label: t("worksheet:lockdown_application"),
      icon: <PolicyOutlined />,
    },
  ];
  const timeDurationSetting = _.first(timeDuration) || {};

  return (
    <>
      <div>
        {showWorksheetTypesHeading && (
          <div className={classes.groupTitle}>
            <WorksheetClipboardOutlined size="xx-small" />
            <span className="text-label-2">{t("common:type")}</span>
          </div>
        )}
        <div className={classes.cardSelectionContainer}>
          {_.map(timeSettings, (timeSetting, index) => {
            const { value, key, label, description } = timeSetting;
            return (
              <CardSelection
                dsVersion="2.0"
                key={key}
                type="radio"
                value={value}
                title={label}
                subtitle={description}
                containerStyle={containerStyles}
                selectedValues={[selectedValue]}
                onCardSelectionClick={onTimeSettingSelectionClick}
                testId={`DeliverySettingsV2-card-selection-${_.camelCase(
                  value
                )}`}
              />
            );
          })}
        </div>
      </div>
      {isTimedTestEnabled && !getIsWorksheetAssignModalV2Enabled() && (
        <div className={classes.timeContainer}>
          <div className={classes.groupTitle}>
            <ClockOutlined size="xx-small" />
            <span className="text-label-2">
              {t("worksheet:timed_worksheet_setup")}
            </span>
          </div>
          <div className={classes.timePickerContainer}>
            <div>
              <div className={classes.securityButtonLabel}>
                {t("common:time_duration")}
              </div>
              <DurationDropdown {...timeDurationSetting} t={t} />
            </div>
            <div>
              <div className={classes.securityButtonLabel}>
                {t("worksheet:security_mode")}
              </div>
              <Dropdown
                overlay={
                  <DropdownMenu
                    options={securityOptions}
                    onClick={changeSecurityMode}
                  />
                }
                testId={"DeliverySettingsV2-secure-browser-dropdown"}
                dsVersion="2.0"
              >
                <Button
                  dsVersion="2.0"
                  type="outlined"
                  variant="neutral"
                  size="medium"
                  icon={_.find(securityOptions, { key: securityMode })?.icon}
                  rightIcon={<CaretDownFilled />}
                  className={classes.securityButton}
                  testId={"DeliverySettingsV2-secure-browser-button"}
                >
                  {_.find(securityOptions, { key: securityMode })?.label}
                </Button>
              </Dropdown>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeliverySettingsV2;
